import "components/jiffy/breadcrumbs/breadcrumbs";
import initFaqPage from "components/jiffy/faq/faq";

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".js-faq-page")) initFaqPage();
});
